import { useDispatch } from "react-redux";
import { Modal, Button } from "components/common";
import { closeRequestUserAccount } from "redux/request/userAccountSlice";
import { toast } from "react-toastify";
import { FaCheckCircle } from "react-icons/fa";
import React from 'react';
import PropTypes from 'prop-types';

const CloseRequestUserAccountConfirm = ({ open, setOpen, record }) => {
  const dispatch = useDispatch();

  const closeModal = () => {
    setOpen(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await dispatch(closeRequestUserAccount({
        recordId: record.id,
        data: { manual: true }
      })).unwrap();

      closeModal();
    }
    catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <Modal
      show={open}
      onHide={closeModal}
      title="Close Request User Account"
      backdropClick={false}
      footer={(
        <div className="tw-flex tw-justify-center tw-gap-2 tw-w-full">
          <Button type="submit" variant="success" className="tw-px-4" form="close-request-user-account-form">
            <FaCheckCircle className="tw-mr-2" /> Yes, Close
          </Button>
          <Button variant="ghost" onClick={closeModal} className="tw-px-4">
            Cancel
          </Button>
        </div>
      )}
    >
      <form id="close-request-user-account-form" onSubmit={handleSubmit}>
        <div className="tw-text-center">
          <FaCheckCircle size={48} className="tw-text-yellow-500 tw-mb-3" />
          <p className="tw-text-sm">
            Are you sure you want to <strong>close</strong> the request to create a new user account for <strong>{record.full_of_name}</strong>?
          </p>
          <small className="tw-text-slate-500">
            This action cannot be undone.
          </small>
        </div>
      </form>
    </Modal>
  );
};

CloseRequestUserAccountConfirm.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  record: PropTypes.object.isRequired
};

export default CloseRequestUserAccountConfirm;
